/* FIFTH & BEAM — editorial navigation. For Designers v2 uses a structured service index. */
(function () {
  const configs = {
    'About': {
      mode: 'editorial',
      eyebrow: 'Who we are',
      title: 'About',
      summary: 'The company, working showroom and practical checks behind the collection.',
      roman: 'V.',
      descriptions: [
        'The people, place and point of view behind FIFTH & BEAM.',
        'Real sample walls and packed fixtures in Guzhen.',
        'How structure, light, finish and packing are checked.',
        'Why a ceiling-first edit is useful for U.S. orders.'
      ]
    },
    'For Designers': {
      mode: 'services',
      eyebrow: 'Professional support',
      audience: 'For designers, builders, hospitality teams and multi-room U.S. projects.',
      items: [
        {
          title: 'For Designers',
          services: ['Specification review', 'Fixture schedules', 'Project quotations'],
          cta: 'View designer support'
        },
        {
          title: 'Custom Lighting',
          services: ['Dimensions, drops and canopy', 'Finishes and material options', 'Written scope and production coordination'],
          cta: 'Start a custom brief'
        }
      ]
    }
  };

  function createText(tag, className, value) {
    const element = document.createElement(tag);
    element.className = className;
    element.textContent = value;
    return element;
  }

  function createArrow() {
    const arrow = document.createElement('img');
    arrow.className = 'fb-mega__arrow';
    arrow.src = window.FifthBeamMegaMenu?.arrowIcon || '';
    arrow.alt = '';
    arrow.setAttribute('aria-hidden', 'true');
    return arrow;
  }

  function decorateEditorialMenu(list, links, config) {
    const intro = document.createElement('li');
    intro.className = 'fb-mega__intro';
    const introTop = document.createElement('div');
    introTop.append(
      createText('span', 'fb-mega__eyebrow', config.eyebrow),
      createText('h2', 'fb-mega__title', config.title),
      createText('p', 'fb-mega__summary', config.summary)
    );
    intro.append(introTop, createText('span', 'fb-mega__roman', config.roman));

    const linkColumn = document.createElement('li');
    linkColumn.className = 'fb-mega__links';
    links.forEach((link, index) => {
      const existingTitle = link.textContent.trim();
      link.replaceChildren();
      link.className = 'fb-mega__link-row';
      link.append(
        createText('span', 'fb-mega__index', String(index + 1).padStart(2, '0')),
        createText('span', 'fb-mega__link-title', existingTitle),
        createText('span', 'fb-mega__description', config.descriptions[index]),
        createArrow()
      );
      linkColumn.append(link);
    });

    list.replaceChildren(intro, linkColumn);
    list.classList.add('fb-mega-menu');
  }

  function decorateServiceMenu(list, links, config) {
    const intro = document.createElement('li');
    intro.className = 'fb-mega__intro fb-mega__intro--designers';
    intro.append(
      createText('span', 'fb-mega__eyebrow', config.eyebrow),
      createText('p', 'fb-mega__audience', config.audience)
    );

    const columns = links.map((link, index) => {
      const item = config.items[index];
      if (link.textContent.trim() !== item.title) return null;
      link.replaceChildren();
      link.className = 'fb-mega__service-link';
      const services = createText('span', 'fb-mega__service-list', '');
      item.services.forEach((service) => {
        services.append(createText('span', 'fb-mega__service-item', service));
      });
      const cta = createText('span', 'fb-mega__service-cta', '');
      cta.append(createText('span', '', item.cta), createArrow());
      link.append(
        createText('span', 'fb-mega__service-title', item.title),
        services,
        cta
      );
      const column = document.createElement('li');
      column.className = 'fb-mega__service-column';
      column.append(link);
      return column;
    });
    if (columns.some((column) => !column)) return false;

    list.replaceChildren(intro, ...columns);
    list.classList.add('fb-mega-menu', 'fb-mega-menu--designers');
    return true;
  }

  function decorateMenu(item, label, config) {
    const list = item.querySelector('.mega-menu__list');
    if (!list || list.dataset.fbEditorial === 'true') return;

    const links = Array.from(list.querySelectorAll('a.mega-menu__link'));
    const expectedLength = config.mode === 'services' ? config.items.length : config.descriptions.length;
    if (links.length !== expectedLength) return;

    const decorated = config.mode === 'services'
      ? decorateServiceMenu(list, links, config)
      : (decorateEditorialMenu(list, links, config), true);
    if (!decorated) return;

    list.dataset.fbEditorial = 'true';
    list.dataset.fbEditorialVersion = config.mode === 'services' ? '2' : '1';
    item.dataset.fbEditorialMenu = label.toLowerCase().replace(/\s+/g, '-');
  }

  function initializeEditorialMenus(root) {
    const scope = root?.querySelectorAll ? root : document;
    scope.querySelectorAll('.menu-list__list-item').forEach((item) => {
      const label = item.querySelector(':scope > .menu-list__trigger .menu-list__link-title')?.textContent.trim();
      if (configs[label]) decorateMenu(item, label, configs[label]);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeEditorialMenus(document));
  } else {
    initializeEditorialMenus(document);
  }

  let refreshQueued = false;
  const observer = new MutationObserver(() => {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(() => {
      refreshQueued = false;
      initializeEditorialMenus(document);
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => initializeEditorialMenus(event.target));
})();
